import { render, staticRenderFns } from "./EditSocialMedia.vue?vue&type=template&id=0c4a38ad&scoped=true&"
import script from "./EditSocialMedia.vue?vue&type=script&lang=js&"
export * from "./EditSocialMedia.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=0c4a38ad&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4a38ad",
  null
  
)

export default component.exports